// extracted by mini-css-extract-plugin
export default {"container":"packageLocation_container__RZnjB","location":"packageLocation_location__pTAvT","map":"packageLocation_map__dEAaz"};